<template>
  <div class="content" style="background-color: #ffffff;">
    <!-- <div class="sign-banner"></div> -->
    <br/>
    <h3>免费自助企业签名</h3>
    <br/>
    <div class="container">
      <!-- <div class="alert alert-info">
        <van-notice-bar mode="closeable" speed="30">
          <span
            class="notice-li"
          >1,本平台提供24小时在线签名服务，用户登录后，选择相应套餐，上传ipa文件即可，如遇到打包问题、网站封装问题，可直接联系QQ客服无偿处理</span>
          <span class="notice-li">2,暂时仅支持微信支付，支付宝、网银、公司用户请联系客服，另行处理</span>
          <span class="notice-li">3,更新及掉签等问题可通过平台签名管理中 更新/补签进行自助签名处理</span>
        </van-notice-bar>
      </div> -->
      <div class="sign-panel">
        <!-- <h2>在线签名</h2> -->
        <div class="sign-incell">
          <form class="form-inline">
            <div class="form-group mb-2">
              <input type="text" readonly class="form-control-plaintext" value="IPA文件">
            </div>
            <div class="mx-sm-3 mb-2">
              <el-form size="mini" ref="form">
                <el-upload class="upload-demo" ref="upload" drag :action="uploadUrl()" :data="requestParams()"
                  :multiple="false" :auto-upload="false" :limit="1" :on-change="fileChange" :on-success="uploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div style="color:#579FF8;font-weight:bold" class="el-upload__tip" slot="tip">只能上传ipa文件</div>
                </el-upload>
              </el-form>
            </div>
          </form>
          <form class="form-inline">
            <div class="form-group mb-2">
              <input type="text" readonly class="form-control-plaintext" value="自动解锁">
            </div>
            <div class="mx-sm-3 mb-2">
              <el-switch v-model="unlock" @change="clickUnlock"></el-switch>
            </div>
          </form>
          <form v-if="unlock" class="form-inline">
            <div class="form-group mb-2">
              <input type="text" readonly class="form-control-plaintext" value="有效动态库">
            </div>
            <div class="mx-sm-3 mb-2">
              <textarea class="form-control" v-model="excludeDylibNames" placeholder="非必填项 请输入应用包内依赖的动态库名称，如有多个按空格键分隔"
                cols="50" rows="3"></textarea>
            </div>
          </form>
          <!-- <form class="form-inline">
            <div class="form-group mb-2">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                id="staticEmail2"
                value="选择套餐"
              >
            </div>

            <div
              v-for="(mealType,index) in mealTypeList"
              class="form-check mx-sm-3 mb-2"
            >
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="meal"
                  :value="mealType.id"
                  v-model="mealTypeId"
                  @click="selectMealType(mealType.id)"
                >
                {{mealType.mealName}}
              </label>
            </div>
          </form>
          <form class="form-inline">
            <div class="form-group mb-2">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                value="选择时间"
              >
            </div>
            <div v-for="(mealInfo,index) in mealInfos" class="form-check mx-sm-3 mb-2">
              <label v-if="mealInfos.length==1 || index==1" class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="selectDay"
                  @click="selectDay(mealInfo.effectiveDays)"
                  :value="mealInfo.effectiveDays"
                  checked="checked"
                >{{mealInfo.effectiveDays}}天
                <span class="badge badge-danger">推荐</span>
              </label>
              <label v-else class="form-check-label">
                <input
                  class="form-check-input"
                  type="radio"
                  name="selectDay"
                  @click="selectDay(mealInfo.effectiveDays)"
                  :value="mealInfo.effectiveDays"
                >{{mealInfo.effectiveDays}}天
              </label>
            </div>
          </form>
          <form class="form-inline">
            <div class="form-group mb-2">
              <input
                type="text"
                readonly
                class="form-control-plaintext price-control"
                value="价格"
              >
            </div>
            <div class="form-price-check mx-sm-3 mb-2">
              <input
                type="text"
                readonly
                class="form-control-plaintext text-warin"
                :value="signMeal.mealPrice"
              >
            </div>
          </form> -->
          <form class="form-inline">
            <button type="button" style="width:10em" @click="autoSign" class="btn btn-sign btn-primary"
              :disabled="autoSignBtnDisable">在线签名</button>
          </form>
          <div v-if="startUpload" class="progress">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" aria-valuenow="25"
              aria-valuemin="0" aria-valuemax="100" :style="'width:'+progress">{{progress}}</div>
          </div>
        </div>
        <div class="form-tips">
          <div class="hd">温馨提示：</div>
          <div class="bd">
            <p>1.APP闪退、签名不成功等情况请联系客服进行处理</p>
            <p>2.出现APP掉签情况，请直接通过更新APP方式进行补签操作，掉签时系统将自动为掉签APP免费补充一次更新机会如有问题联系客服</p>
            <p>3.平台严禁上传色情、博彩等法律规定的违规应用，管理员有权直接删除不合规应用</p>
          </div>
        </div>
        <autoSignPayWindow v-if="open_modal" :pay_link="payLink" v-on:showModal="showModal"></autoSignPayWindow>
      </div>
    </div>
    <AutoSignOrderDetail v-if="showAutoSignOrderDetail" :autoSignOrder="autoSignOrder"
      v-on:closeOrderDetail="closeAutoSignOrderDetail" />
  </div>
</template>

<script>
var self;
// console.log()
import autoSignPayWindow from "./AutoSignPayWindow";
import AutoSignOrderDetail from "./AutoSignOrderDetail";
export default {
  name: "HelloWorld",
  components: {
    autoSignPayWindow,
    AutoSignOrderDetail
  },
  mounted() {
    self = this;
    this.getAccount(data => {
      this.getMealList();
    });
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/token", {
        authToken: this.getToken()
      })
      .then(response => {
        self.respDataHandle(response.body, function(respData) {
          self.account = respData;
          self.$emit("setNoLogin", false);
          self.$emit("setAccount", respData);
        });
      });
  },
  data() {
    return {
      msg: "Welcome to Your Vue js App",
      mealTypeList: [],
      validDay: 0,
      mealTypeId: 0,
      signMeal: {},
      startUpload: false,
      progress: "0%",
      open_modal: false,
      payLink: "",
      filePath:
        "请上传ipa文件，如无法打包ipa或需要进行网页封装等操作请直接联系客服操作",
      autoSignBtnDisable: true,
      showAutoSignOrderDetail: false,
      autoSignOrder: null,
      unlock: true,
      excludeDylibNames: "",
      mealInfos: [],
      dayToMealInfoDict: {}
    };
  },
  methods: {
    getMealList: function() {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auto/sign/meal/type/getAll")
        .then(response => {
          this.respDataHandle(response.data, function(data) {
            self.mealTypeList = data;
            self.mealTypeId = data[0].id;
            self.getMealInfos();
          });
        });
    },
    selectMealType: function(mealTypeId) {
      this.mealTypeId = mealTypeId;
      this.getMealInfos();
    },
    selectDay: function(day) {
      this.validDay = day;
      this.getMealPrice(day);
    },
    getMealInfos: function() {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auto/sign/meal", {
          mealTypeId: this.mealTypeId
        })
        .then(response => {
          this.respDataHandle(response.body, function(data) {
            self.mealInfos = data;
            self.dayToMealInfoDict = {};
            $.each(data, function(index, value) {
              self.dayToMealInfoDict[value.effectiveDays] = value;
            });
            if (self.validDay == 0) {
              if (data.length >= 2) {
                self.selectDay(data[1].effectiveDays);
              } else {
                self.selectDay(data[0].effectiveDays);
              }
            } else {
              console.log("tag", self.dayToMealInfoDict[self.validDay]);
              if (self.dayToMealInfoDict[self.validDay] == undefined) {
                if (data.length >= 2) {
                  self.selectDay(data[1].effectiveDays);
                } else {
                  self.selectDay(data[0].effectiveDays);
                }
              } else {
                self.selectDay(self.validDay);
              }
            }
          });
        });
    },
    getMealPrice: function(day) {
      this.signMeal = this.dayToMealInfoDict[parseInt(day)];
    },
    uploadUrl: function() {
      var url = "https://autosign.35ff.vip/auth/auto/sign/task";
      url = this._Global.HTTP_SERVER + "/auth/auto/sign/task";
      return url;
    },
    requestParams: function() {
      return {
        mealTypeId: this.mealTypeId,
        authToken: this.getToken(),
        excludeDylibNames: this.excludeDylibNames,
        days: this.validDay
      };
    },
    autoSign: function() {
      this.$refs.upload.submit();
    },
    showModal(open_modal) {
      this.open_modal = open_modal;
    },
    fileChange: function(file, fileList) {
      var fileName = file.name;
      if (fileName.substr(fileName.length - 3, fileName.length) != "ipa") {
        window.layer.msg("请选择ipa文件");
        this.autoSignBtnDisable = true;
        return;
      }
      this.autoSignBtnDisable = false;
    },
    closeAutoSignOrderDetail: function() {
      this.showAutoSignOrderDetail = false;
      window.location.reload();
    },
    clickUnlock: function() {
      this.excludeDylibNames = "";
    },
    uploadSuccess: function(response, file, fileList) {
      this.respDataHandle(
        response,
        data => {
          if (data == "") {
            this.$router.push({ name: "AutoSignManager" });
            return;
          }
          this.autoSignOrder = data;
          this.showAutoSignOrderDetail = true;
        },
        function() {
          window.layer.close(layerIndex);
        }
      );
    }
  }
};
</script>

<style scoped>
form {
  margin-bottom: 1em;
}
.form-check-label .badge {
  position: relative;
  top: -8px;
}
</style>



// WEBPACK FOOTER //
// src/components/SignOnline.vue